import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { forwardRef } from 'react';
import { Icon, Label } from '~/components/granular';
import { classNames } from '~/utils/styles';
import type { CheckboxDetailProps, CheckboxProps } from './Checkbox.types';

export const Checkbox = forwardRef<HTMLDivElement, CheckboxProps>(
  ({ id, checked, detail, className, disabled, label, appearance = 'light', ...props }, forwardedRef) => {
    const classes = classNames(
      'm-0.5 flex h-max min-h-4 w-max min-w-4 rounded-[1px] border disabled:border-neutral-400',
      {
        'border-teal-700 bg-teal-700 disabled:bg-neutral-400': checked,
      },
    );

    const checkedIcon = checked === 'indeterminate' ? 'SubtractIcon' : 'CheckIcon';

    return (
      <div className={classNames('flex items-center', className)} ref={forwardedRef}>
        <RadixCheckbox.Root checked={checked} className={classes} disabled={disabled} id={id} {...props}>
          <RadixCheckbox.Indicator>
            {checked && <Icon className="text-white" icon={checkedIcon} />}
          </RadixCheckbox.Indicator>
        </RadixCheckbox.Root>

        <div className="flex flex-col">
          {label && (
            <Label appearance={appearance} disabled={disabled} htmlFor={id}>
              {label}
            </Label>
          )}

          <CheckboxDetail detail={detail} />
        </div>
      </div>
    );
  },
);

function CheckboxDetail({ detail }: CheckboxDetailProps) {
  if (!detail) {
    return null;
  }

  return <span className="pl-2 text-sm whitespace-nowrap text-neutral-800">{detail}</span>;
}
